const Regex = {
  firstSpaceBlock: new RegExp(/^[^ ](.*|\n|\r|\r\n)*/),
  mobileNumber: new RegExp(/(^\s*$)|(^09[0-9]{9}$)/),
  tenDigit: new RegExp(/^\d{10}$/),
  amount: new RegExp(/^(3\d{6,}|[4-9]\d{5,}|[1-9]\d{7,})$/),
  pass: new RegExp(/^(?=.*[A-Z])(?=.*\d).{8,15}$/),
  number: new RegExp(/(^[\s/0-9]*$)/),
};

export default Regex;
